// Mock data for Nobel Rijschool - Replace with actual data

export const siteInfo = {
  name: "Nobel Rijschool",
  tagline: "Snel en Succesvol je Rijbewijs Halen",
  phone: "+31 6 85400443",
  whatsapp: "+31 6 85400443",
  email: "info@nobelrijschool.nl",
  address: "Schrijverspark 76- 01, 3901 PR Veenendaal",
  kvk: "93353936"
};

export const heroData = {
  title: "SNEL JE RIJBEWIJS HALEN MET NOBEL",
  subtitle: "Meld je vandaag aan en ontvang direct 30% korting op je proefles. Start morgen bij de beste rijschool in de regio.",
  ctaText: "Proefles met 30% korting Aanvragen",
  image: "https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=1200&q=80"
};

export const features = [
  {
    title: "Ervaren Instructeurs",
    description: "Onze gekwalificeerde instructeurs hebben jarenlange ervaring en een hoog slagingspercentage."
  },
  {
    title: "Flexibele Lestijden",
    description: "Plan je lessen wanneer het jou uitkomt. Ook 's avonds en in het weekend mogelijk."
  },
  {
    title: "Moderne Auto's",
    description: "Leer rijden in comfortabele, goed onderhouden auto's met de nieuwste veiligheidsvoorzieningen."
  },
  {
    title: "Hoog Slagingspercentage",
    description: "Dankzij onze effectieve lesmethode slaagt het merendeel van onze leerlingen in één keer."
  },
  {
    title: "Geen Wachttijden",
    description: "Start direct met je rijlessen. Bij ons heb je geen maandenlange wachttijden en kun je ook in de avond rijlessen volgen."
  },
  {
    title: "Transparante Prijzen",
    description: "Geen verborgen kosten. Je weet precies waar je aan toe bent met onze duidelijke tarieven."
  }
];

export const whyChooseUs = [
  "Ervaren en Gekwalificeerde Instructeurs",
  "Morgen starten met je proefrijles",
  "Hoog Slagingspercentage",
  "Flexibele Lesuren 6 dagen per week",
  "Moderne en Veilige Voertuigen",
  "Persoonlijke Aandacht en Begeleiding",
  "Transparante en Eerlijke Tarieven",
  "korting op de Proefles voor Nieuwe Leerlingen"
];

export const courses = [
  {
    id: 1,
    name: "Standaard Rijcursus",
    description: "Perfect voor beginners. Leer stap voor stap alle vaardigheden die je nodig hebt om veilig te rijden.",
    duration: "30-40 lessen",
    includes: [
      "Theorie ondersteuning",
      "Praktijklessen",
      "Tussentijdse toets",
      "Examen begeleiding"
    ]
  },
  {
    id: 2,
    name: "Intensieve Cursus",
    description: "Haal je rijbewijs in recordtijd! Ideaal als je snel je rijbewijs nodig hebt.",
    duration: "2-4 weken",
    includes: [
      "Meerdere lessen per week",
      "Snelle planning",
      "Intensieve begeleiding",
      "Spoedexamen mogelijk"
    ]
  },
  {
    id: 3,
    name: "Automaat Rijlessen",
    description: "Rijlessen in een auto met automatische versnelling. Makkelijker en sneller te leren.",
    duration: "25-35 lessen",
    includes: [
      "Automatische transmissie",
      "Kortere leertijd",
      "Moderne auto's",
      "Volledige begeleiding"
    ]
  },
  {
    id: 4,
    name: "Faalangst Begeleiding",
    description: "Speciaal programma voor leerlingen die faalangst ervaren. Met extra aandacht en geduld.",
    duration: "Op maat",
    includes: [
      "Rustige aanpak",
      "Extra oefentijd",
      "Mentale coaching",
      "Persoonlijke begeleiding"
    ]
  }
];

export const pricingPackages = [
  {
    name: "Proefles",
    price: "30% Korting",
    duration: "60 minuten",
    features: [
      "Kennismaking met instructeur",
      "Eerste rijervaring",
      "Persoonlijk advies",
      "Geen verplichtingen"
    ],
    popular: false
  },
  {
    name: "20 Lessen Pakket",
    price: "€1200",
    duration: "20 x 60 minuten",
    features: [
      "Vaste instructeur",
      "Flexibele planning",
      "Theorie ondersteuning",
      "€60 per les",
      "Exclusief examenkosten"

    ],
    popular: false
  },
  {
    name: "30 Lessen Pakket",
    price: "€1750",
    duration: "30 x 60 minuten",
    features: [
      "Vaste instructeur",
      "Snel beginnen",
      "tussentijdse toets",
      "Beste prijs-kwaliteit",
      "Exclusief examenkosten"
    ],
    popular: true
  },
  {
    name: "40 Lessen Pakket",
    price: "€2300",
    duration: "40 x 60 minuten",
    features: [
      "Vaste instructeur",
      "Meeste oefentijd",
      "tussentijdse toets",
      "Hoogste slagingskans",
      "Exclusief examenkosten"

    ],
    popular: false
  }
];

export const additionalPricing = [
  { service: "Losse Les", price: "€63" },
  { service: "Praktijkexamen (CBR)", price: "€300" },
  { service: "Tussentijdse Toets ()TTT", price: "€250" },
  { service: "Eigen Verklaring", price: "€45" },
  { service: "Faalangst Traject", price: "Op aanvraag" }
];

export const testimonials = [
  {
    id: 1,
    name: "Emma de Vries",
    rating: 5,
    text: "Super rijschool! In één keer geslaagd dankzij de goede begeleiding. Mijn instructeur was geduldig en professioneel.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80",
    date: "December 2024"
  },
  {
    id: 2,
    name: "Lucas van Dam",
    rating: 5,
    text: "Geweldige ervaring! De lessen waren leuk en leerzaam. Aanrader voor iedereen die zijn rijbewijs wil halen.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
    date: "November 2024"
  },
  {
    id: 3,
    name: "Sophie Bakker",
    rating: 5,
    text: "Had veel faalangst, maar dankzij de rustige aanpak van mijn instructeur ben ik toch geslaagd. Heel blij!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80",
    date: "Oktober 2024"
  },
  {
    id: 4,
    name: "Daan Jansen",
    rating: 5,
    text: "Professionele rijschool met moderne auto's. Flexibele lestijden en goede prijs-kwaliteit verhouding.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80",
    date: "September 2024"
  },
  {
    id: 5,
    name: "Lisa Vermeulen",
    rating: 5,
    text: "Eerste keer geslaagd met het 30 lessen pakket. De instructeur wist precies waar ik aan moest werken.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80",
    date: "Augustus 2024"
  },
  {
    id: 6,
    name: "Mike de Jong",
    rating: 5,
    text: "Top rijschool! Snel kunnen starten en binnen 3 maanden mijn rijbewijs. Heel tevreden!",
    image: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80",
    date: "Juli 2024"
  }
];

export const successPhotos = [
  "https://images.unsplash.com/photo-1630406144797-821be1f35d75?w=600&q=80",
  "https://images.unsplash.com/photo-1578041262130-633307b3bfd6?w=600&q=80",
  "https://images.pexels.com/photos/9518022/pexels-photo-9518022.jpeg?w=600&q=80",
  "https://images.pexels.com/photos/9518029/pexels-photo-9518029.jpeg?w=600&q=80",
  "https://images.unsplash.com/photo-1623795457671-600b1223c2db?w=600&q=80",
  "https://images.unsplash.com/photo-1634539990685-4d7241a89bad?w=600&q=80",
  "https://images.pexels.com/photos/248539/pexels-photo-248539.jpeg?w=600&q=80",
  "https://images.unsplash.com/photo-1553782097-130fef5d3e27?w=600&q=80"
];

export const faqData = [
  {
    question: "Hoeveel rijlessen heb ik gemiddeld nodig?",
    answer: "Gemiddeld hebben leerlingen 35-40 lessen nodig. Dit kan variëren afhankelijk van je leervermogen, eerdere ervaring en hoe vaak je les neemt."
  },
  {
    question: "Kan ik ook in het weekend rijles krijgen?",
    answer: "Ja, wij bieden rijlessen aan op alle dagen van de week, inclusief weekenden. Je kunt zelf je lestijden plannen die het beste bij je schema passen."
  },
  {
    question: "Wat als ik voor mijn examen zak?",
    answer: "Geen probleem! We bespreken wat er beter kan en plannen extra lessen om aan je zwakke punten te werken. Je kunt dan opnieuw examen doen."
  },
  {
    question: "Hoe snel kan ik starten met rijlessen?",
    answer: "Meestal kun je binnen een week starten. Na je aanmelding plannen we zo snel mogelijk je eerste proefles in."
  },
  {
    question: "Wat moet ik meenemen naar mijn eerste rijles?",
    answer: "Neem je geldig identiteitsbewijs mee. Als je al een theorie-certificaat hebt, neem dat ook mee. Verder is het handig om comfortabele schoenen te dragen."
  },
  {
    question: "Kan ik ook lessen krijgen in een automaat?",
    answer: "Ja, wij bieden rijlessen aan in zowel handgeschakelde als automatische auto's. Automatische lessen zijn vaak korter omdat schakelen niet geleerd hoeft te worden."
  },
  {
    question: "Zijn de examens inbegrepen in de pakketten?",
    answer: "De examenkosten zijn niet inbegrepen in de lespakketten. Deze bedragen ongeveer €300 voor het praktijkexamen en worden apart betaald."
  },
  {
    question: "Kan ik mijn pakket gespreid betalen?",
    answer: "Ja, wij bieden verschillende betaalmogelijkheden aan. Je kunt je pakket in termijnen betalen. Neem contact met ons op voor de mogelijkheden."
  }
];